/**
 * Enumeration of the SQL table names used throughout the application.
 * 
 * This enum provides a centralized registry of table names to ensure consistent
 * references across the application's database operations.
 * 
 * @enum {string}
 */
export enum UsedSqlTables {
    APP_STATES = "states"
}